
import { UserLoginClass } from "@utilities/user_login_class";

const UserLogin = (function() {
  let instance: UserLoginClass;

  function createInstance() {
    const user_login = new UserLoginClass();
    return user_login;
  }

  return {
    getInstance: function() {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();


export default UserLogin;
